import { questionnaireManagementSlice } from "modules/settings/modules/questionnaires/_redux/questionnaireSlice";
import { initialInterviewGuideSlice } from "modules/settings/modules/interviewGuides/_redux/interviewGuideSlice";
import { candidateManagementSlice } from "modules/candidates/_redux/candidateSlice";
import { dashboardManagementSlice } from "modules/dashboard/_redux/dashboardSlice";
import { interviewManagementSlice } from "modules/interviewSchedule/_redux/interviewSlice";
import { documentTemplateSlice } from "modules/settings/modules/document-template/_redux/documentTemplateSlice";
import { reportManagementSlice } from "modules/reports/_redux/reportsSlice";
import { userManagementSlice } from "modules/user-management/_redux/userManagementSlice";
import { emailTemplateSlice } from "modules/settings/modules/email-template/_redux/emailTemplateSlice";
import { jobManagementSlice } from "modules/jobs/_redux/jobSlice";
import { categoriesSlice } from "modules/settings/modules/categories/_redux/categoriesSlice";
import { combineReducers } from "@reduxjs/toolkit";
import { EvaluationSlice } from "modules/settings/modules/evaluation-template/_redux/evaluationSlice";
import { persistReducer } from "redux-persist";
import { workFlowSlice } from "modules/settings/modules/workflows/_redux/workFlowSlice";
import { profileSlice } from "modules/settings/modules/profile/_redux/profileSlice";
import { loaderSlice } from "components/shared/globalLoader/_redux/loaderSlice";
import { toastSlice } from "modules/Toast/_redux/toastSlice";
import { authSlice } from "modules/auth/_redux/authSlice";
import { vacancyRequisitionManagementSlice } from "modules/vacancyRequisition/_redux/vacancyRequisitionSlice";
import storage from "redux-persist/lib/storage";

export const userPersistConfig = {
  key: "authToken",
  storage,
  whitelist: ["token"],
};

const jobPersistConfig = {
  key: "selectedJobId",
  storage,
  whitelist: ["selectedJobId"],
};

const candidatePersistConfig = {
  key: "filtersForNextPreCandidate",
  storage,
  whitelist: ["filtersForNextPreCandidate"],
};

const rootReducer = combineReducers({
  auth: persistReducer(userPersistConfig, authSlice.reducer),
  toast: toastSlice.reducer,
  profile: profileSlice.reducer,
  reports: reportManagementSlice.reducer,
  workflow: workFlowSlice.reducer,
  documents: documentTemplateSlice.reducer,
  categories: categoriesSlice.reducer,
  evaluations: EvaluationSlice.reducer,
  globalLoader: loaderSlice.reducer,
  questionnaire: questionnaireManagementSlice.reducer,
  emailTemplate: emailTemplateSlice.reducer,
  jobManagement: persistReducer(jobPersistConfig, jobManagementSlice.reducer),
  userManagement: userManagementSlice.reducer,
  interviewGuide: initialInterviewGuideSlice.reducer,
  candidateManagement: persistReducer(candidatePersistConfig, candidateManagementSlice.reducer),
  dashboardManagement: dashboardManagementSlice.reducer,
  interviewManagement: interviewManagementSlice.reducer,
  vacancyRequisitionManagement: vacancyRequisitionManagementSlice.reducer,
});

export default rootReducer;
